import { z } from "zod";
/**
 * Contracts of the cuentas tributarias (plan 017): queries of ARCA's Sistema de Cuentas
 * Tributarias per company, imported from its Excel or recorded by hand when there is no debt.
 * Amounts travel as decimal text and may be negative (a balance in favour is never netted).
 */
const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "La fecha tiene que ser AAAA-MM-DD.");
export const TAX_ACCOUNT_SOURCES = ["arca_sct", "manual"];
/**
 * The state of one query. `sin_informacion` is the company without any query: it is never shown
 * as «sin deuda», because no data does not prove there is no debt.
 */
export const TAX_ACCOUNT_STATUSES = ["deuda", "a_revisar", "sin_deuda", "sin_informacion"];
export const TAX_ACCOUNT_STATUS_LABELS = {
    deuda: "Deuda a pagar",
    a_revisar: "Saldos a revisar",
    sin_deuda: "Sin deuda informada",
    sin_informacion: "Sin información",
};
/**
 * «Cómo leer los importes», as Mathias wrote them in his prototype (v0.11). They go to the client
 * in the PDF and the Excel; the wording is the studio's to validate.
 */
export const TAX_ACCOUNT_EXPLANATIONS = [
    {
        title: "Capital pendiente",
        body: "Importe de la obligación original que continúa pendiente de pago, sin incluir los intereses mostrados por separado.",
    },
    {
        title: "Intereses resarcitorios",
        body: "Intereses generados por pagar fuera de término o mantener una obligación impaga.",
    },
    {
        title: "Intereses punitorios",
        body: "Intereses aplicables cuando la deuda se reclama por vía judicial, desde la presentación de la demanda. No equivalen a intereses sobre intereses.",
    },
    {
        title: "Total a pagar",
        body: "Suma del capital pendiente y los intereses resarcitorios y punitorios informados a la fecha de cálculo.",
    },
];
export const TAX_ACCOUNT_DATE_NOTE = "Importes al día indicado. Para pagar en otra fecha, actualizar los intereses en ARCA.";
/** Recording a query that showed no debt: the date queried and the explicit confirmation. */
export const taxAccountNoDebtSchema = z.object({
    interestsOn: isoDate,
    confirmed: z.literal(true, {
        error: "Confirmá que verificaste en ARCA que la consulta no informa deuda.",
    }),
});
/** True when a sum holds balances in favour, shown in their own column «a revisar». */
export function hasBalanceInFavour(amounts) {
    return /[1-9]/.test(amounts.inFavour);
}
/** «202605» → «05/2026»; anything else (a year, a special period) as ARCA wrote it. */
export function formatSctPeriod(period) {
    const match = /^(\d{4})(\d{2})$/.exec(period.trim());
    if (!match)
        return period;
    const month = Number(match[2]);
    if (month === 0)
        return match[1] ?? period;
    return month <= 12 ? `${match[2]}/${match[1]}` : period;
}
//# sourceMappingURL=tax-accounts.js.map